import { useMediaQuery } from '@mui/material';
import { isNativeShell } from '../utils/distribution';

/**
 * Native app in phone landscape (short viewport height), regardless of width.
 * Pixel-class devices exceed the md width breakpoint when rotated.
 */
export function useNativeCompactLandscape(): boolean {
  const isLandscape = useMediaQuery('(orientation: landscape)');
  const isShortViewport = useMediaQuery('(max-height: 520px)');
  return isNativeShell() && isLandscape && isShortViewport;
}
